export default "__VITE_ASSET__CgSPJ4PK__"